var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, ViewChild, Inject } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import * as _ from 'lodash';
import { WordExceptBHDataType } from '../../../core/variable/flag-data-type';
import { VARIABLE_SERVICE } from '../../../core/variable/variable.service';
import { finalize } from 'rxjs/operators';
import { VariableName } from '../../../core/variable/variable-name';
var RingGraphGeneralSettingComponent = /** @class */ (function (_super) {
    __extends(RingGraphGeneralSettingComponent, _super);
    function RingGraphGeneralSettingComponent(injector, variableService, dataTypeService, rotationDirectionService) {
        var _this = _super.call(this, injector) || this;
        _this.variableService = variableService;
        _this.dataTypeService = dataTypeService;
        _this.rotationDirectionService = rotationDirectionService;
        _this.dataType = WordExceptBHDataType;
        return _this;
    }
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentVariableId)) {
                return;
            }
            this._currentVariableId = v;
            this.data.configureVariableId = v;
            this.currentVariableIdChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "currentVariable", {
        get: function () {
            return this._currentVariable;
        },
        set: function (v) {
            if (v === this._currentVariable) {
                return;
            }
            this._currentVariable = v;
            this.data.variableDataType = v.dataType;
            this.validateCalibration();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "selectedRotationDirection", {
        get: function () {
            return this._rotationDirection;
        },
        set: function (v) {
            if (_.isEqual(this._rotationDirection, v)) {
                return;
            }
            this.data.rotationDirection = v;
            this._rotationDirection = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "isFullRing", {
        get: function () {
            return this._isFullRing;
        },
        set: function (v) {
            this._isFullRing = v;
            this.data.isFullRing = v;
            if (v) {
                this.endAngle = this._startAngle;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "startAngle", {
        get: function () {
            return this._startAngle;
        },
        set: function (v) {
            this.data.startAngle = v;
            this._startAngle = v;
            if (this._isFullRing) {
                this.endAngle = this._startAngle;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "endAngle", {
        get: function () {
            return this._endAngle;
        },
        set: function (v) {
            this.data.endAngle = v;
            this._endAngle = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "radiusPercentage", {
        get: function () {
            return this._radiusPercentage;
        },
        set: function (v) {
            this.data.radiusPercentage = v;
            this._radiusPercentage = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "minCalibration", {
        get: function () {
            return this._minCalibration;
        },
        set: function (v) {
            this.data.minCalibration = v;
            this._minCalibration = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphGeneralSettingComponent.prototype, "maxCalibration", {
        get: function () {
            return this._maxCalibration;
        },
        set: function (v) {
            this.data.maxCalibration = v;
            this._maxCalibration = v;
        },
        enumerable: true,
        configurable: true
    });
    RingGraphGeneralSettingComponent.prototype.ngOnInit = function () {
        this.initData();
    };
    RingGraphGeneralSettingComponent.prototype.validateRadiusPercentage = function () {
        if (_.isNil(this.radiusPercentage)) {
            this.radiusPercentage = 0;
            return;
        }
        if (this.radiusPercentage < 0) {
            this.radiusPercentage = 0;
        }
        if (this.radiusPercentage > 99) {
            this.radiusPercentage = 99;
        }
    };
    RingGraphGeneralSettingComponent.prototype.validateMinCalibration = function () {
        if (_.isNil(this.minCalibration)) {
            this.minCalibration = 0;
            return;
        }
        if (this.currentVariable) {
            if (this.currentVariable.dataType) {
                var dataTypeMinValue = this.dataTypeService.getMinValue(this.currentVariable.dataType);
                this.minCalibration = this.minCalibration < dataTypeMinValue ? dataTypeMinValue : this.minCalibration;
            }
        }
    };
    RingGraphGeneralSettingComponent.prototype.validateMaxCalibration = function () {
        if (_.isNil(this.maxCalibration)) {
            this.maxCalibration = 0;
            return;
        }
        if (this.currentVariable) {
            if (this.currentVariable.dataType) {
                var dataTypeMaxValue = this.dataTypeService.getMaxValue(this.currentVariable.dataType);
                this.maxCalibration = this.maxCalibration > dataTypeMaxValue ? dataTypeMaxValue : this.maxCalibration;
            }
        }
    };
    RingGraphGeneralSettingComponent.prototype.validateCalibration = function () {
        if (this.currentVariable && this.currentVariable.dataType) {
            var dataTypeMaxValue = this.dataTypeService.getMaxValue(this.currentVariable.dataType);
            this.maxCalibration = this.maxCalibration > dataTypeMaxValue ? dataTypeMaxValue : this.maxCalibration;
            var dataTypeMinValue = this.dataTypeService.getMinValue(this.currentVariable.dataType);
            this.minCalibration = this.minCalibration < dataTypeMinValue ? dataTypeMinValue : this.minCalibration;
        }
    };
    RingGraphGeneralSettingComponent.prototype.validateStartAngle = function () {
        if (_.isNil(this.startAngle)) {
            this.startAngle = 0;
            return;
        }
        if (this.startAngle < 0) {
            this.startAngle = 0;
        }
        if (this.startAngle > 360) {
            this.startAngle = 360;
        }
    };
    RingGraphGeneralSettingComponent.prototype.validateEndAngle = function () {
        if (_.isNil(this.endAngle)) {
            this.endAngle = 0;
            return;
        }
        if (this.endAngle < 0) {
            this.endAngle = 0;
        }
        if (this.endAngle > 360) {
            this.endAngle = 360;
        }
    };
    RingGraphGeneralSettingComponent.prototype.validateMaximumMinimum = function (currentFormControl) {
        var allControlls = currentFormControl.parent.controls;
        var minCalibrationControl = allControlls['MinCalibration'];
        var maxCalibrationControl = allControlls['MaxCalibration'];
        if (!minCalibrationControl || !maxCalibrationControl) {
            return undefined;
        }
        if (_.isNil(maxCalibrationControl.value) || _.isNil(minCalibrationControl.value)) {
            return undefined;
        }
        if (!_.isNumber(maxCalibrationControl.value) || !_.isNumber(minCalibrationControl.value)) {
            return undefined;
        }
        if (minCalibrationControl.value >= maxCalibrationControl.value) {
            return { 'maximumMinimumValidate': true };
        }
        else {
            if (minCalibrationControl.errors) {
                delete minCalibrationControl.errors.maximumMinimumValidate;
                if (Object.keys(minCalibrationControl.errors || {}).length === 0) {
                    minCalibrationControl.setErrors(undefined);
                }
            }
            if (maxCalibrationControl.errors) {
                delete maxCalibrationControl.errors.maximumMinimumValidate;
                if (Object.keys(maxCalibrationControl.errors || {}).length === 0) {
                    maxCalibrationControl.setErrors(undefined);
                }
            }
        }
        return undefined;
    };
    RingGraphGeneralSettingComponent.prototype.initData = function () {
        var _this = this;
        this.rotationDirections = this.rotationDirectionService.getRotationDirectionStatus();
        var data = this.data;
        if (data.configureVariableId.variableVersion) {
            this.currentVariableId = VariableName.tryParse(data.configureVariableId.name, data.configureVariableId.variableVersion);
        }
        else if (!_.isNil(data.variableId.dataSourceCode)) {
            this.variableService.getVariableName(data.variableId.dataSourceCode, data.variableId.variableName.name, data.variableId.variableName.groupName).subscribe(function (value) {
                _this.currentVariableId = value;
            });
        }
        this._rotationDirection = data.rotationDirection;
        this._isFullRing = data.isFullRing;
        this._startAngle = data.startAngle;
        this._endAngle = data.endAngle;
        this._radiusPercentage = data.radiusPercentage;
        this._minCalibration = data.minCalibration;
        this._maxCalibration = data.maxCalibration;
    };
    RingGraphGeneralSettingComponent.prototype.currentVariableIdChanged = function () {
        var _this = this;
        var variableId = this.currentVariableId;
        if (variableId && variableId.name) {
            this.isLoading = true;
            this.variableService.findVariable(variableId)
                .pipe(finalize(function () { _this.isLoading = false; }))
                .subscribe(function (variable) {
                _this.currentVariable = variable;
            });
        }
        else {
            this.currentVariable = undefined;
        }
    };
    __decorate([
        Input()
    ], RingGraphGeneralSettingComponent.prototype, "configureId", void 0);
    __decorate([
        ViewChild('startAngleInput', { static: false })
    ], RingGraphGeneralSettingComponent.prototype, "startAngleInput", void 0);
    __decorate([
        Input()
    ], RingGraphGeneralSettingComponent.prototype, "data", void 0);
    RingGraphGeneralSettingComponent = __decorate([
        Component({
            selector: 'ring-graph-general',
            template: "<div [busyIf]=\"isLoading\" provide-parent-forms class=\"fe-modal-body fe-modal-content\"> <div class=\"fe-vertical-label\"> <label class=\"fe-vertical-title\">{{lc(\"RotationDirection\")}}:</label> <select class=\"fe-vertical-input\" name=\"direction\" [(ngModel)]=\"selectedRotationDirection\"> <option *ngFor=\"let rotationDirection of rotationDirections\" [value]=\"rotationDirection.id\"> {{lc(rotationDirection.name)}} </option> </select> </div> <div class=\"fe-option-head\"> <label> <input type=\"checkbox\" name=\"isFullRing\" [(ngModel)]=\"isFullRing\"> <span>{{lc(\"FullRing\")}}</span> </label> </div> <div class=\"clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc(\"StartAngle\")}}:</label> <input type=\"number\" #startAngleInput class=\"fe-vertical-input\" name=\"startAngle\" [(ngModel)]=\"startAngle\" (change)=\"validateStartAngle()\" /> </div> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc(\"EndAngle\")}}:</label> <input type=\"number\" class=\"fe-vertical-input\" name=\"endAngle\" [(ngModel)]=\"endAngle\" [(disabled)]=\"isFullRing\" (change)=\"validateEndAngle()\" /> </div> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc(\"RadiusPercentage\")}}:</label> <input type=\"number\" class=\"fe-vertical-input\" name=\"radiusPercentage\" [(ngModel)]=\"radiusPercentage\" (change)=\"validateRadiusPercentage()\" /> </div> </div> <div class=\"clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc(\"MinimumValue\")}}</label> <input type=\"number\" class=\"fe-vertical-input\" name=\"MinCalibration\" #MinCalibration=\"ngModel\" [(ngModel)]=\"minCalibration\" (change)=\"validateMinCalibration()\" [custom-func-validate]=\"validateMaximumMinimum\" required /> <div class=\"text-danger\" *ngIf=\"MinCalibration.invalid && (MinCalibration.dirty || MinCalibration.touched)\"> <span *ngIf=\"MinCalibration.errors.required\"> {{l('Required')}} </span> <span *ngIf=\"MinCalibration.errors.maximumMinimumValidate\"> {{lc('MaximumMinimumValidateInfo')}}</span> </div> </div> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc(\"MaximumValue\")}}</label> <input type=\"number\" class=\"fe-vertical-input\" name=\"MaxCalibration\" #MaxCalibration=\"ngModel\" [(ngModel)]=\"maxCalibration\" (change)=\"validateMaxCalibration()\" [custom-func-validate]=\"validateMaximumMinimum\" required /> <div class=\"text-danger\" *ngIf=\"MaxCalibration.invalid && (MaxCalibration.dirty || MaxCalibration.touched)\"> <span *ngIf=\"MaxCalibration.errors.required\"> {{l('Required')}}</span> <span *ngIf=\"MaxCalibration.errors.maximumMinimumValidate\"> {{lc('MaximumMinimumValidateInfo')}}</span> </div> </div> </div> <div class=\"fe-vertical-label\"> <label class=\"fe-vertical-title\">{{lc(\"VariableName\")}}:</label> <div class=\"fe-vertical-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> </div>"
        }),
        __param(1, Inject(VARIABLE_SERVICE))
    ], RingGraphGeneralSettingComponent);
    return RingGraphGeneralSettingComponent;
}(ConfigureComponentBase));
export { RingGraphGeneralSettingComponent };
